export const PILL_BUTTON = 'h-8 rounded-full text-[13px] font-normal';

/**
 * View mode renders the same controls disabled. The shared components fade a disabled control to
 * half opacity; the design shows a saved nudge at full strength, read only, so the fade is undone
 * here rather than by restyling the shared components for every other screen.
 */
const READ_ONLY = 'disabled:opacity-100 disabled:cursor-default';

export const ROW_SELECT = `h-9 rounded-[10px] border-gray-400 text-[13px] text-ink data-[size=default]:h-9 ${READ_ONLY}`;

export const ROW_INPUT = `h-9 rounded-[10px] border-gray-400 text-[13px] text-ink md:text-[13px] placeholder:text-gray-700 ${READ_ONLY}`;

/** Figma text field 6768:39851. No resize grip: the design has none in the corner. */
export const PANEL_TEXTAREA = `min-h-20 resize-none rounded-2xl border border-gray-500 bg-white p-3 text-xs leading-[1.1] text-ink shadow-none md:text-xs placeholder:text-gray-800 ${READ_ONLY}`;

export const PANEL_CARD = 'flex flex-col rounded-2xl border border-gray-300 bg-white p-4';

export const ADD_BUTTON = `${PILL_BUTTON} w-fit gap-1.5 px-3 text-ink shadow-none ${READ_ONLY}`;

/** Figma field menu 6490:84683: the hovered row gets a grey state layer, the text stays body colour. */
export const FIELD_MENU_ITEM =
	'h-7 rounded-[10px] text-[13px] text-ink focus:bg-[rgba(29,27,32,0.08)] focus:text-ink';
